export default {
  DNS_RECORD(state, payload) {
    state.DNSData = payload;
  },
};
